import React from 'react';
import { Box, Typography } from '@mui/material';
import IconReusable from '../../../components/IconReusable';
import { useSelector } from 'react-redux';

const ConfirmBusinessInfoSection = ({
  isMobile,
  gstFlow,
  gstDetails,
  panDetails,
  operationalDetails,
  fieldErrors,
  onEdit,
  editable,
  pan_details
}) => {

  const showHistory = useSelector(state => state.entityReducer.show_history);
  return (
    <Box
      sx={{
        background: '#fff',
        borderRadius: 2,
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant='labelD'>
          Business Information
        </Typography>
        {editable && (
            <Box
            onClick={onEdit}
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                cursor: 'pointer',
                width: '24px',
                height: '24px',
                justifyContent: 'center',
            }}
            disabled={showHistory}
            >
            <IconReusable name='Edit' color={!showHistory ? '#333' : '#E5E5E5' }  size={isMobile ? 16 : 24} />
            </Box>
        )}
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', py: 1 }}>
        <Typography variant='labelD' sx={{ color: '#666666', minWidth: '160px' }}>
          {gstDetails?.gst_number ? 'GST' : 'PAN'}
        </Typography>
        <Typography variant='body1' sx={{ color: !gstFlow && fieldErrors?.pan_number ? '#D32F2F' : 'inherit' }}>
          {gstDetails?.gst_number ?  gstDetails?.gst_number : gstDetails?.pan_number || panDetails?.pan_number }
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', py: 1 }}>
        <Typography variant='labelD' sx={{ color: '#666666', minWidth: '160px' }}>
          Firm Name
        </Typography>
        <Typography variant='body1'>
          {gstDetails?.gst_number ? gstDetails?.firm_name : panDetails?.firm_name || gstDetails?.firm_name}
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', py: 1 }}>
        <Typography variant='labelD' sx={{ color: '#666666', minWidth: '160px' }}>
          Address
        </Typography>
        <Typography variant='body1' sx={{ textTransform: 'capitalize' }}>
          {operationalDetails && [
            operationalDetails?.address_line_1,
            operationalDetails?.address_line_2,
            operationalDetails?.district_name,
            operationalDetails?.location_name,
            operationalDetails?.state_name,
            operationalDetails?.pincode_id,
          ].filter(Boolean).join(', ')}
        </Typography>
      </Box>
    </Box>
  );
};

export default ConfirmBusinessInfoSection;
